// extracted by mini-css-extract-plugin
export default {"toastContainer":"SecondLayout_toastContainer__KLXXk"};